import { alpha } from '@mui/material';

import { legacyColors } from '~/legacyTheme';

export const useSxStyles = () => {
  return {
    help: {
      color: legacyColors.icon.help,
      '&:hover': {
        backgroundColor: alpha(legacyColors.icon.help, 0.1),
      },
    },
  };
};
